import { clearTokens, setTokens } from '../Api/authToken';

export const isValidAuthToken = (token) => {
  if (typeof token !== 'string') return false;
  const value = token.trim();
  if (!value || value === 'undefined' || value === 'null') return false;
  return value.length >= 10;
};

export const persistUserSession = (userData) => {
  if (!userData || typeof userData !== 'object') {
    throw new Error('Invalid login response');
  }

  const access = userData.access_token || userData.token;
  const refresh = userData.refersh_token || userData.refresh_token || '';

  if (!isValidAuthToken(access)) {
    throw new Error('Missing access token');
  }

  const normalized = {
    ...userData,
    access_token: access,
    refersh_token: refresh,
  };

  setTokens('user', access, refresh);
  localStorage.setItem('loggedUser', JSON.stringify(normalized));
  if (normalized.active_status_token) {
    localStorage.setItem('active_status_token', normalized.active_status_token);
  }
  return normalized;
};

export const getUserAccessToken = () => localStorage.getItem('user_access_token');

export const isUserSessionActive = () => isValidAuthToken(getUserAccessToken());

export const clearInvalidUserSession = () => {
  if (!isUserSessionActive()) {
    clearTokens('user');
    localStorage.removeItem('active_status_token');
    return true;
  }
  return false;
};
